/**
 * مفاتيح تشغيل/تعطيل ميزات العرض (Feature flags).
 * مصدر حقيقة واحد — لا تكرّر شروط الإخفاء في المكوّنات.
 */

/**
 * اليوميات (/journal):
 *  false = الروابط مخفيّة من الفوتر والبحث والسايت ماب،
 *          لكنّ الصفحة نفسها تبقى تعمل لمن يعرف الرابط.
 *  true  = إعادة الظهور بكبسة واحدة.
 */
export const JOURNAL_LINKS_ENABLED = false;
